export default __webpack_public_path__ + "static/media/minted.1fd7a609.jpg";